export { default } from "./setActiveSpan";
